import { HttpClient,HttpResponse,HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject,of, Observable } from 'rxjs';
// import dataL from "../../assets/json/vessel_details_8feb_11am.json";
import { map, filter, switchMap,catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import * as FileSaver from 'file-saver';
import {saveAs} from 'file-saver';
@Injectable({
 providedIn: 'root'
})
export class approvalService {

 private approvalStageMessage = new BehaviorSubject(null);
 currentApprovalStageMessage = this.approvalStageMessage.asObservable();
 baseUrl= environment.API_URL;
 fetchData(queryParams) {
  //get/ship/lycan_range
    return this.http.get(this.baseUrl+"/laycanRange",{params:queryParams}).pipe(map((response: any) => {
      return response;
    }))
  }
  getRegionList() {
    //list_region_data
    return this.http.get(this.baseUrl+"/regionList",{}).pipe(map((response: any) => {
      return response.data;
    }))
  }
  getFileName(response:any) {
    let filename: string;
    try {
      const contentDisposition: string = response.headers.get('content-disposition');
      console.log("hhhh")
      const r = /(?:filename=")(.+)(?:;")/
      filename = r.exec(contentDisposition)[1];
    }
    catch (e) {
      filename = 'myfile.txt'
    }
    return filename
  }
  postExcelExport(body){
    let formData: FormData = new FormData(); 
    formData.append('from',body.from); 
    formData.append('to', body.to);
    formData.append('region', body.region);
    formData.append('columns', body.columns);
    formData.append('CONFIDENCE', body.CONFIDENCE);
    formData.append('DWT', body.DWT);
    formData.append('VESSEL', body.VESSEL);
    formData.append('OPERATOR', body.OPERATOR);
    formData.append('AGE', body.AGE);
    formData.append('TANK_TYPE', body.TANK_TYPE);
    this.http.post(this.baseUrl+'/laycanRangeDownloadExcel',formData,{responseType: 'blob' }).subscribe((res:any) => {
      /* console.log(res)
      console.log(res.headers)
      console.log(res.headers.get('content-disposition'))
      var headers = this.getFileName(res);
      console.log(headers) */
      let date = new Date();
      let fileName = `supply_forecasting_${date.getFullYear()}${date.getMonth()+1}${date.getDate()}`
      saveAs(res, `${fileName}.csv`)
    },err=>{
      console.log("error",err)
    });
  }
 constructor(private http: HttpClient) {

 }
 updateApprovalMessage(message: any) {
 this.approvalStageMessage.next(message)
 }
}